import React, { useState } from 'react';
import { Modal, Form, Row, Col, Button } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';
import { PERMISSION_LABELS } from 'constants/admin/user';

const WarehousePermissionModal = ({
  show,
  onHide,
  warehouse,
  permission,
  permFieldDefs = [],
  editing,
  onSave,
}) => {
  const [values, setValues] = useState({});

  const perm = permission || {};
  const editValues = { ...perm, ...values };

  const handleChange = (field, value) => {
    setValues(prev => ({ ...prev, [field]: value }));
  };

  const handleSave = () => {
    onSave(warehouse.id, { ...perm, ...values });
    handleClose();
  };

  const handleClose = () => {
    setValues({});
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fs-6">
          {warehouse?.name} &mdash; Permissions
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Row className="mb-3 align-items-center">
          <Col xs={6} className="fw-semibold">
            Manager
          </Col>
          <Col xs={6}>
            {editing ? (
              <Form.Check
                type="switch"
                checked={editValues.is_manager ?? false}
                onChange={e => handleChange('is_manager', e.target.checked)}
              />
            ) : (
              <SubtleBadge pill bg={perm.is_manager ? 'success' : 'secondary'}>
                {perm.is_manager ? 'Yes' : 'No'}
              </SubtleBadge>
            )}
          </Col>
        </Row>

        <hr />

        {permFieldDefs.map(f => {
          const options = (f.options || [0, 1, 2, 3]).map(v => ({
            value: v,
            label: PERMISSION_LABELS[v] ?? v,
          }));

          return (
            <Row key={f.key} className="mb-3 align-items-center">
              <Col xs={6} className="fw-semibold">
                {f.label}
              </Col>
              <Col xs={6}>
                {editing ? (
                  <Form.Select
                    size="sm"
                    value={editValues[f.key] ?? 0}
                    onChange={e => handleChange(f.key, Number(e.target.value))}
                  >
                    {options.map(opt => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  PERMISSION_LABELS[perm[f.key]] ?? perm[f.key] ?? 'None'
                )}
              </Col>
            </Row>
          );
        })}
      </Modal.Body>

      {editing && (
        <Modal.Footer>
          <Button variant="secondary" size="sm" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" size="sm" onClick={handleSave}>
            Apply
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};

export default WarehousePermissionModal;
